import { useLaunchDarklyFlag } from "../../utils/ld-cache";
var MiniLD = function(props) {
    var _props_LaunchDarklyConfig = props.LaunchDarklyConfig, flag = _props_LaunchDarklyConfig.flag, clientId = _props_LaunchDarklyConfig.clientId, user = _props_LaunchDarklyConfig.user, _props_LaunchDarklyConfig_placeholder = _props_LaunchDarklyConfig.placeholder, placeholder = _props_LaunchDarklyConfig_placeholder === void 0 ? null : _props_LaunchDarklyConfig_placeholder, children = props.children;
    var value = useLaunchDarklyFlag(flag, false, {
        clientId: clientId,
        user: user
    });
    if (value) {
        return children;
    }
    return placeholder;
};
export { MiniLD };

//# sourceMappingURL=MiniLD.js.map